export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/sumoday-filter.51515722.svg","height":24,"width":92};